<template>
  <div class="log-device-masker flex-center">
    <div class="log-content">
      <div class="log-con-header">
        <span class="log-header-title">
          {{dataInfo?dataInfo.device_name:'摄像头'}}
        </span>
        
        <Icon @click='close' class='c-blue icon' type="md-close" />
      </div>
      <div fc class="log-con-body theme flex-center" style="width: 64vw;height: 36vw;">
        <camera v-if="dataInfo" :cameraInfo="dataInfo"></camera>
      </div>
    </div>
  </div>
</template>

<script>
import { getFarmCameraList } from './../api/agri.js'
import camera from './camera/abstractCamera.vue';
import { mapGetters } from "vuex";

export default {
  props: ["info"],
  data() {
    return {
      macInfo: {
        marker: false,
        imei: ''
      },
      dataInfo: null
    }
  },
  components: {
    camera
  },
	computed: {
    ...mapGetters(["getFarmId"])
	},
  created() {
    this.dataInfo = null
    this.macInfo = {
      marker: this.info.name || false,
      imei: this.info.mac,
    }

    getFarmCameraList(this.getFarmId).then(res => {
      let videoList = res.data.data || []
      
      let list = videoList[0].camera_list || []
      let c = list.find(item => item.id == this.info.mac)

      if (c) {
        if (c.app_key) c.appkey = c.app_key
        if (c.app_secret) c.appsecret = c.app_secret
        
        this.dataInfo = c
      }
    })
  },
  methods: {
    close() {
      this.$emit("closeMask");
    }
  }
};
</script>

<style scoped>
.ivu-spin-fix {
  opacity: 0.6;
  background: transparent;
}

.log-con-body {
  background: rgba(0, 36, 62, 0.8);
  padding: 0.75vw 1vw;
}

.c-blue {
  color: #01bae1;
}

.icon:last-child {
  cursor: pointer;
  margin-left: auto;
  right: 0;
  font-size: 1vw;
}

.icon {
  font-size: 1vw;
}

.log-header-title {
  text-align: right;
  font-size: 1vw;
  flex-shrink: 0;
  padding-right: 0.5vw;
}

.log-con-header {
  font-size: 0.7vw;
  line-height: 1;
  display: flex;
  align-items: center;
  background: rgba(0, 14, 25, 0.8);
  padding: 0.6vw 1vw;
}

.log-content div {
  box-sizing: content-box;
}

.log-content {
  position: relative;
  border: 0.05vw solid #02a6ca;
  box-shadow: 0 0 0.2vw 0.2vw rgba(2, 166, 202, 0.4);
}

.log-device-masker {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
